import { PatientImportModal } from './components';
import { config } from 'config';
import { headers } from './fixtures';
import { patientActions } from 'core/Patient';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    EmptyButton,
    ExpandButton,
    Loader,
    MaterialIcon,
    PageController
} from 'mol-ui';
import {
    ContainerStyled,
    ControllerContainer,
    ItemContainer,
    ItemText,
    ItemTitle,
    TableContent
} from './styled';
import {
    ExternalLoginModal,
    ListingLayout
} from 'views/components';
import React, { useEffect, useState } from 'react';
import {
    isLocked,
    isSuperadmin
} from 'shared/utils';
import {
    useDispatch,
    useObjectState,
    useSelector,
    useToggle
} from 'hooks';
const {
    patientImport,
    patientRegistration
} = config;

const PatientListing = () => {

    const { disabledColor } = useTheme();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        page,
        pageDownload,
        pageDownloading,
        pageLoading: loading,
        pageRender
    } = useSelector('patient');
    const {
        user,
        user: { email }
    } = useSelector('account');
    const { push } = useHistory();

    const [externalLoginModal, setExternalLoginModal] = useState(false);
    const [patientsList, setPatientsList] = useState([]);
    const [currentFilters, setCurrentFilters] = useObjectState({});
    const [importActive, toggleImportActive] = useToggle(false);

    const downloadController = {
        data: pageDownload,
        downloading: pageDownloading,
        fileName: t('Pacientes'),
        headers: headers.filter(({ hidden }) => !hidden),
        onDownload: () => dispatch(patientActions.getPatientPageDownload())
    };

    useEffect(() => {
        dispatch(patientActions.getPatientPage());
    }, []);

    useEffect(() => {
        if (!!page || pageRender) {
            setPatientsList(page.getData().data);
        }
    }, [page, pageRender, setPatientsList]);

    const handleAction = action => {
        if (action === 'loadAll') {
            dispatch(patientActions.getPatientPage({
                ...currentFilters,
                one_page: 1
            }));
        }
    };

    const handleFilter = value => {
        const { filter, search } = value;
        const newFilters = {
            search,
            ...(filter === 'created_at' && {
                order_by: 'created_at',
                order_way: 'desc'
            })
        };
        setCurrentFilters(newFilters);
        dispatch(patientActions.getPatientPage(newFilters));
    };

    const handleNewPatient = () => {
        dispatch(patientActions.setPatientCreation(''));
        dispatch(patientActions.setPatientRegistrationError({}));
        push(t('/pacientes/crear'));
    };

    const allowPatientCreate = !isLocked(user, 'patients_create');

    return (
        <ListingLayout
            actions={ [{
                action: 'loadAll',
                label: t('Cargar todos')
            }] }
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            filterLabel={ t('Ordenar') }
            filterOptions={ [{
                label: t('Apellido'),
                value: 'last_name'
            }, {
                label: t('Nuevos primero'),
                value: 'created_at'
            }]
            }
            onAction={ handleAction }
            onFilterChange={ handleFilter } >
            <ExternalLoginModal
                active={ externalLoginModal }
                profile="patient"
                onToggle={ () => setExternalLoginModal(false) }
            />
            <ButtonFooter justify="flex-start" padding="0px 10px">
                {
                    patientImport && allowPatientCreate &&
                    <ExpandButton
                        caption={ t('Importar pacientes') }
                        margin="5px 10px 0px 0px"
                        size={ 60 }
                        width={ 150 }
                        onClick={ toggleImportActive }
                    />
                }
                {
                    patientRegistration && allowPatientCreate &&
                    <ExpandButton
                        caption={ t('Nuevo paciente') }
                        margin="5px 10px 0px 0px"
                        size={ 60 }
                        width={ 150 }
                        onClick={ handleNewPatient }
                    />
                }
                {
                    isSuperadmin(email) &&
                    <ExpandButton
                        caption={ t('Login externo') }
                        margin="5px 10px 0px 0px"
                        size={ 60 }
                        width={ 150 }
                        onClick={ () => setExternalLoginModal(true) }
                    />
                }
            </ButtonFooter>
            <ContainerStyled>
                <TableContent>
                    {
                        !loading
                            ? <>
                                {
                                    (patientsList ?? []).map(patient => {
                                        const { deleted, enabled, first_name = '-', id, identification, last_name = '-', mandatory_password_change = 0 } = patient;
                                        const fullName = `${ last_name }, ${ first_name }`;
                                        const deletedString = !deleted ? '' : ` (${ t('Eliminado') })`;
                                        const enabledString = enabled ? '' : ` (${ t('Deshabilitado') })`;
                                        const mandatoryString = !mandatory_password_change ? '' : ` (${ t('Contraseña requerida') })`;
                                        return (
                                            <ItemContainer key={ id }>
                                                <EmptyButton onClick={ () => push(`${ t('/pacientes/historial') }/${ id }`) } >
                                                    <ItemTitle>
                                                        <span>{ `${ fullName }${ deletedString }${ enabledString }${ mandatoryString }` }</span>
                                                        <MaterialIcon color={ disabledColor } icon="open_in_new" size={ 12 } />
                                                    </ItemTitle>
                                                    <ItemText>{ t('DNIPaciente') }: { identification}</ItemText>
                                                </EmptyButton>
                                            </ItemContainer>
                                        );
                                    })
                                }
                                <ControllerContainer>
                                    <PageController controller={ page } />
                                </ControllerContainer>
                            </>
                            : <Loader active={ true } />
                    }
                </TableContent>
            </ContainerStyled>
            {
                patientImport &&
                <PatientImportModal
                    active={ importActive }
                    onToggle={ toggleImportActive }
                />
            }
        </ListingLayout>
    );

};

export default PatientListing;
